module.exports = __webpack_public_path__ + "7f363b2c7cb7da7e038e2540697e546f.png";